// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.close-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 4px 8px;
  line-height: 1;
  z-index: 1;
}
.close-button:hover {
  color: #333;
}
.close-button:focus {
  outline: none;
  border: none;
}

.custom-alert-dialog {
  padding: 24px;
  padding-top: 32px;
  min-width: 300px;
  max-width: 450px;
  text-align: center;
}

.dialog-content {
  margin-bottom: 24px;
  padding-top: 8px;
}

.dialog-title {
  font-size: 28px;
  font-weight: 700;
  color: #0b2d71;
  margin: 0 0 16px 0;
  line-height: 1.2;
}

.message {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

.okay-button {
  width: 100%;
  padding: 12px 24px;
  background-color: #0066cc;
  color: white;
  border: none;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.okay-button:hover {
  background-color: #0052a3;
}
.okay-button:focus {
  outline: 2px solid #0066cc;
  outline-offset: 2px;
}
.okay-button:active {
  background-color: #004080;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
